// src/utils/chineseTranslation.js
import {Converter} from 'opencc-js';

const converter = Converter({ from: 'tw', to: 'cn' });

function translateToSimplifiedChinese(text) {
  return converter(text);
}

export {translateToSimplifiedChinese};